import dayjs from "dayjs";

import { TimeseriesData } from "@/types";
import "@/pages/index/ForecastDataset.scss";

export const ForecastDataset = ({ dataset }: { dataset: TimeseriesData[] }) => {
	const formatDate = (date) => {
		return dayjs(date).format("DD.MM.YYYY");
	};

	return (
		<div className="forecast-detail">
			<div className="row">
				<div className="col-12 col-lg-12">
					<p>
						<strong>Actual state of the latest model dataset</strong>
					</p>
					<table className="dataset-table">
						<tbody>
							<tr>
								<th style={{ width: "170px" }}>Symbol</th>
								<th style={{ width: "100px" }}>Date</th>
								<th style={{ width: "100px" }}>Price</th>
								<th>Description</th>
							</tr>
							{dataset?.map((item) => (
								<tr key={item.name}>
									<td>{item.name}</td>
									<td>{formatDate(item.date)}</td>
									<td>{item.value}</td>
									<td>{item.description}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
};
